import { render, staticRenderFns } from "./SizeGuideDrawer.vue?vue&type=template&id=10915ebb&scoped=true&"
import script from "./SizeGuideDrawer.vue?vue&type=script&lang=js&"
export * from "./SizeGuideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SizeGuideDrawer.vue?vue&type=style&index=0&id=10915ebb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10915ebb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/UI/UiIcon.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default})
